<template>
    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.78 37">
        <title>phone</title>
        <g id="smartphone">
            <g id="_Groupe_" data-name="&lt;Groupe&gt;"><path d="M19.28,5.7H.5A.5.5,0,0,1,0,5.2V3A3,3,0,0,1,3,0H16.82a3,3,0,0,1,3,3V5.2A.5.5,0,0,1,19.28,5.7ZM1,4.7H18.78V3a2,2,0,0,0-2-2H3A2,2,0,0,0,1,3Z" style="fill: #fff" /></g>
            <g id="_Groupe_2" data-name="&lt;Groupe&gt;"><path d="M16.82,37H3.05A3.05,3.05,0,0,1,0,33.95V30.24a.5.5,0,0,1,.5-.5H19.28a.5.5,0,0,1,.5.5V34A3,3,0,0,1,16.82,37ZM1,30.74v3.21A2.05,2.05,0,0,0,3.05,36H16.82a2,2,0,0,0,2-2v-3.3Z" style="fill: #fff" /></g>
            <path d="M19.28,30.74H.5a.5.5,0,0,1-.5-.5V5.2a.5.5,0,0,1,.5-.5H19.28a.5.5,0,0,1,.5.5v25A.5.5,0,0,1,19.28,30.74ZM1,29.74H18.78V5.7H1Z" style="fill: #fff" />
        </g>
    </svg>
</template>

<script>
export default {
    name: "PhoneIcon",
};
</script>

<style scoped>
</style>
./Phone.vue
